/* eslint-disable */
import {
  InjectedModalProps,
  ModalContainer,
  ModalTitle,
  useMatchBreakpoints,
  CloseIcon,
  Text,
  Flex,
  IconButton,
  Button,
  Input,
  Box,
} from '@noahswap/uikit'
import { useTranslation } from '@noahswap/localization'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import styled from 'styled-components'
import { useWeb3React } from '@noahswap/wagmi'
import Column, { AutoColumn, ColumnCenter } from 'components/Layout/Column'
import Row, { RowFixed, RowBetween } from 'components/Layout/Row'
import { useState, useCallback, KeyboardEvent, useRef, RefObject, useEffect } from 'react'
import MenuItem from '@noahswap/uikit/src/components/MenuItem/MenuItem'
import { CurrencyLogo } from 'components/Logo'
import { DoubleCurrencyLogo } from 'views/Info/components/CurrencyLogo'
import { DEFAULT_ACTIVE_LIST_URLS } from 'config/constants/lists'
import CircleLoader from 'components/Loader/CircleLoader'
import { getVotePools } from 'service/service'
import chainUtils from 'service/chainUtils'
import { useRouter } from 'next/router'
import useDebounce from 'hooks/useDebounce'

export const ModalHeader = styled.div<{ background?: string }>`
  align-items: center;
  background: transparent;
  display: flex;
  padding: 12px 24px;
`

export const ModalBody = styled(Flex)`
  align-items: center;
  background: transparent;
  display: flex;
  /* padding: 100px 24px 60px; */
  justify-content: center;
  flex-direction: column;
`
const CoinScroll = styled.div`
  width: 100%;
  height: 250px;
  overflow: auto;
  padding-right: 15px;
`
const ListItem = styled(RowBetween)<{ disabled?: boolean; selected?: boolean }>`
  padding: 4px 0;
  height: 56px;
  display: flex;
  justify-content: space-between;
  cursor: ${({ disabled }) => !disabled && 'pointer'};
`
function CurrencyRow({
  currency = {
    token0: {
      name: 'Binance',
      symbol: 'BNB',
      address: '0x461d52769884ca6235b685ef2040f47d30c94eb5',
    },
    token1: {
      name: 'Ethereum',
      symbol: 'ETH',
      address: '0x922d641a426dcffaef11680e5358f34d97d112e1',
    },
  },
  onSelect,
  isSelected,
}: // otherSelected,
// style,
{
  currency?: any
  onSelect?: () => void
  isSelected?: boolean
  // otherSelected: boolean
  // style: CSSProperties
}) {
  const { account } = useWeb3React()
  const { t } = useTranslation()
  return (
    <ListItem
    // onClick={() => (isSelected ? null : onSelect())}
    >
      <Flex alignItems="center">
        <DoubleCurrencyLogo token0={currency.token0} token1={currency.token1} size={30} />
        <Flex style={{ marginLeft: '30px' }}>
          <Text>{currency?.token0?.symbol}</Text>
          <Text color="#92929B">/{currency?.token1?.symbol}</Text>
        </Flex>
      </Flex>
      {/* <RowFixed style={{ justifySelf: 'flex-end' }}>123</RowFixed> */}
    </ListItem>
  )
}
const LiquidityModal: React.FC<React.PropsWithChildren<any>> = ({ onDismiss, setCoinAddress, coinAddress }: any) => {
  const { isMobile } = useMatchBreakpoints()
  const { t } = useTranslation()
  const [searchQuery, setSearchQuery] = useState<string>('')
  const inputRef = useRef<HTMLInputElement>()
  const { account } = useWeb3React()
  const [listData, setListData] = useState<any>([])
  const [defaultListData, setDefalutListData] = useState<any>([])
  const [pond, setPondData] = useState<any>({})
  const router = useRouter()
  // const parsedQueryChainId = Number(router.query.chainId)
  // const chainId = parsedQueryChainId || Number(localStorage.getItem('chainId')) || 17777
  // const { chainId } = useActiveWeb3React()
  const debouncedQuery = useDebounce(searchQuery, 200)
  // const handleEnter = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
  //   if (e.key === 'Enter') {
  //     console.log(e, 'eee')
  //   }
  // }, [])
  const fetch = async () => {
    const { baseURL, chainid } = chainUtils()
    // const { data, code } = await getGuageCoinList({ baseURL, chainid })
    const { data, code } = await getVotePools({ baseURL, chainid })
    let formatData = []
    if (!code) {
      formatData = data
    }
    setDefalutListData(formatData)
    setListData(formatData)
  }
  const handleSetCoin = (item) => {
    setCoinAddress(item)
    onDismiss()
  }

  useEffect(() => {
    // if (!account) return
    fetch()
  }, [])
  useEffect(() => {
    let copyListData = listData
    console.log(listData, 'listData')
    if (debouncedQuery) {
      copyListData = defaultListData.filter((v) => {
        return (
          v?.symbol0.indexOf(debouncedQuery.toUpperCase()) > -1 || v?.symbol1.indexOf(debouncedQuery.toUpperCase()) > -1
        )
      })
      console.log(copyListData, 'copyListData')
      setListData(copyListData)
    } else {
      setListData(defaultListData)
    }
  }, [debouncedQuery])

  return (
    <ModalContainer $minWidth={isMobile ? '100%' : '418px'} $minHeight={!isMobile ? '300px' : 'auto'}>
      <Box style={{ width: isMobile ? '100% ' : '418px', height: !isMobile ? 'auto' : 'auto' }}>
        <ModalHeader>
          {/* 选择流动池 */}
          <ModalTitle style={{ fontSize: '20px', fontWeight: '500' }}>{t('noah403')}</ModalTitle>
          <IconButton variant="text" onClick={onDismiss}>
            <CloseIcon width="24px" color="#000" />
          </IconButton>
        </ModalHeader>
        <ModalBody>
          <AutoColumn style={{ width: '90%' }}>
            <Row style={{ border: '1px solid #F6F6F6', paddingLeft: '10px', borderRadius: '10px' }}>
              <img src="/images/small-img/icon3.png" width="20px" alt="" />
              <Input
                // 请输入流动池或者粘贴地址
                id="token-search-input"
                placeholder={t('noah404')}
                scale="lg"
                autoComplete="off"
                value={searchQuery}
                ref={inputRef as RefObject<HTMLInputElement>}
                onChange={(event: any) => {
                  setSearchQuery(event.target.value)
                }}
                // onKeyDown={handleEnter}
                style={{ fontWeight: 400 }}
              />
            </Row>
          </AutoColumn>
          <Box
            style={{
              background: '#FAFAFA',
              width: '90%',
              borderRadius: '6px',
            }}
            padding="15px"
            my="16px"
            pr="0"
          >
            <Flex justifyContent="space-between" mb="10px" pr="15px">
              {/* 流动池 */}
              {/* <Text fontSize="12px" color="#85868A">
                {t('noah88')}
              </Text> */}
              {/* 余额 */}
              {/* <Text fontSize="12px" color="#85868A">
                余额
              </Text> */}
            </Flex>
            <CoinScroll>
              {listData.length > 0 ? (
                listData?.map((v: any, i: any) => {
                  const symbolData = {
                    token0: {
                      address: v.contract0,
                      symbol: v.symbol0,
                    },
                    token1: {
                      address: v.contract1,
                      symbol: v.symbol1,
                    },
                    price_direction: v.price_direction,
                  }
                  return (
                    <ListItem
                      // eslint-disable-next-line react/no-array-index-key
                      key={i}
                      onClick={() => {
                        handleSetCoin(v)
                      }}
                    >
                      {symbolData?.price_direction == 1 ? (
                        <Flex alignItems="center">
                          <DoubleCurrencyLogo token0={symbolData.token1} token1={symbolData.token0} size={30} />
                          <Flex style={{ marginLeft: '30px' }}>
                            <Text>{symbolData?.token1?.symbol}</Text>
                            <Text color="#92929B">/{symbolData?.token0?.symbol}</Text>
                          </Flex>
                        </Flex>
                      ) : (
                        <Flex alignItems="center">
                          <DoubleCurrencyLogo token0={symbolData.token0} token1={symbolData.token1} size={30} />
                          <Flex style={{ marginLeft: '30px' }}>
                            <Text>{symbolData?.token0?.symbol}</Text>
                            <Text color="#92929B">/{symbolData?.token1?.symbol}</Text>
                          </Flex>
                        </Flex>
                      )}
                    </ListItem>
                  )
                })
              ) : (
                <Flex justifyContent="center" alignItems="center" flexDirection="column" style={{ height: '240px' }}>
                  <img src="/images/small-img/noData.png" alt="" width="64px" style={{ marginBottom: '10px' }} />
                  <Text color="textSubtle" textAlign="center">
                    {t('noah116')}
                  </Text>
                </Flex>
              )}
            </CoinScroll>
          </Box>
          {/* 找不到想要的流动池，请查看NOAH投票表决的白名单规则 */}
          <Text small mb="50px" textAlign="left" style={{ width: '90%' }} color="#92929B">
            {t('noah350')}
          </Text>
        </ModalBody>
      </Box>
    </ModalContainer>
  )
}
export default LiquidityModal
